import pagesLaborCoreInstanceEn from "./instance/default";
import pagesLaborCoreOperationPackagesEn from "./operation-packages/default";

export default {
  operationPackages: pagesLaborCoreOperationPackagesEn,
  instance: pagesLaborCoreInstanceEn,
};
